<script>
import PopperButtonEditor from './popper/PopperButtonEditor.vue';
export default PopperButtonEditor;
</script>
